"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VehicleTile = void 0;
var _reactRouter = require("@tanstack/react-router");
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactTabs = require("react-tabs");
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _CompareVehicleToggle = _interopRequireDefault(require("../../applications/SearchInventoryTool/atoms/CompareVehicleToggle"));
var _helper = require("../../applications/SearchInventoryTool/helper");
var _new = require("../../applications/SearchInventoryTool/new.helper");
var _IconLibrary = require("../../packages/IconLibrary");
var _analytics = _interopRequireWildcard(require("../analytics"));
var _Disclaimer = _interopRequireDefault(require("../Disclaimer"));
var _LexusButton = _interopRequireDefault(require("../LexusButton"));
var _Link = _interopRequireDefault(require("../Link"));
var _MediaComponent = _interopRequireDefault(require("../MediaComponent"));
var _MoreInfoTooltip = _interopRequireDefault(require("../MoreInfoTooltip"));
var _PriceFormat = _interopRequireDefault(require("../PriceFormat"));
var _Text = _interopRequireDefault(require("../Text"));
var _DGSaveHeart = _interopRequireDefault(require("./DGSaveHeart"));
var Styled = _interopRequireWildcard(require("./VehicleTile/index.styled"));
var Themes = _interopRequireWildcard(require("./VehicleTile/index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const FilterContent = function (_ref) {
  let {
    header,
    includedFilters = [],
    excludedFilters = []
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterTooltipContainer, {
    "data-testid": "FilterContent",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FilterTooltipHeader, {
      className: "tooltipHeader",
      children: header
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterTooltipListingContent, {
      className: "tooltipContent",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterTooltipListingWrapper, {
        className: "tooltipWrapper",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FilterTooltipSubheader, {
          className: "tooltipSubheader",
          children: "Included"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FilterTooltipList, {
          children: includedFilters.map(function (filter) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              "data-testid": "FilterContent",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: filter
              })
            }, filter);
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterTooltipListingWrapper, {
        className: "tooltipWrapper",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FilterTooltipSubheader, {
          className: "tooltipSubheader",
          children: [" ", "Not Included"]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FilterTooltipList, {
          children: excludedFilters.map(function (filter) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              "data-testid": "FilterContent",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: filter
              })
            }, filter);
          })
        })]
      })]
    })]
  });
};
const HeaderVehicleTile = function (props) {
  var _dealer$status, _dealer$status2, _dealer$status3, _dealer$status4, _dealer$status5, _dealer$status6, _window, _window$features;
  const {
    hasFilters,
    status,
    included,
    excluded,
    totalFilterCount,
    tileMsrpHeadingLabel,
    tileMsrpHeadingDisclaimer,
    priceData,
    msrpLegalText,
    hasPreviousView,
    heartProperties,
    isSimilarMatch,
    showDealerIcon,
    dealer,
    isSmartPath
  } = props;
  const themeContext = (0, _styledComponentThemes.useTheme)();
  const theme = typeof themeContext === "string" ? themeContext : themeContext === null || themeContext === void 0 ? void 0 : themeContext.theme;
  const filterContent = {
    content: {
      copy: /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterContent, {
        header: `${included === null || included === void 0 ? void 0 : included.length} of ${totalFilterCount} Filter Matches`,
        includedFilters: included,
        excludedFilters: excluded
      })
    },
    showArrow: true,
    placement: "bottom",
    themeName: "FilterInfoContent",
    hideOnScroll: false
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Status, {
    "data-testid": "HeaderVehicleTile",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.StatusContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StatusFilter, {
        children: !hasFilters && status ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StatusLabel, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: status
            })
          }), showDealerIcon && isSmartPath && (dealer === null || dealer === void 0 ? void 0 : (_dealer$status = dealer.status) === null || _dealer$status === void 0 ? void 0 : _dealer$status.icon) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DealerIcon, {
            className: "hasBorder",
            src: dealer === null || dealer === void 0 ? void 0 : (_dealer$status2 = dealer.status) === null || _dealer$status2 === void 0 ? void 0 : _dealer$status2.icon,
            alt: dealer === null || dealer === void 0 ? void 0 : (_dealer$status3 = dealer.status) === null || _dealer$status3 === void 0 ? void 0 : _dealer$status3.alt
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StatusLabel, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: status
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                marginRight: "3px"
              },
              children: ": "
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StatusFilterLabel, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreInfoTooltip.default, {
              appendTo: "parent",
              ...filterContent,
              brand: theme,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
                children: [included === null || included === void 0 ? void 0 : included.length, " of ", totalFilterCount, " Filters"]
              })
            })
          }), showDealerIcon && isSmartPath && (dealer === null || dealer === void 0 ? void 0 : (_dealer$status4 = dealer.status) === null || _dealer$status4 === void 0 ? void 0 : _dealer$status4.icon) && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DealerIcon, {
            className: "hasBorder",
            src: dealer === null || dealer === void 0 ? void 0 : (_dealer$status5 = dealer.status) === null || _dealer$status5 === void 0 ? void 0 : _dealer$status5.icon,
            alt: dealer === null || dealer === void 0 ? void 0 : (_dealer$status6 = dealer.status) === null || _dealer$status6 === void 0 ? void 0 : _dealer$status6.alt
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.StatusMSRP, {
        className: status ? "hasStatus" : "",
        children: [tileMsrpHeadingLabel, tileMsrpHeadingDisclaimer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Disclaimer.default, {
          theme: theme,
          text: tileMsrpHeadingDisclaimer
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceFormat.default, {
          price: priceData !== null && priceData !== void 0 && priceData.totalMsrp ? priceData.totalMsrp : 0
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StatusMSRPText, {
          children: theme === _helper.LEXUS_THEME ? `, ${msrpLegalText}` : msrpLegalText
        })]
      })]
    }), hasPreviousView && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.PreviouslyViewed, {
      children: "Previously Viewed"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DGSaveHeart.default, {
      disabled: (_window = window) === null || _window === void 0 ? void 0 : (_window$features = _window.features) === null || _window$features === void 0 ? void 0 : _window$features.disableHearts,
      suffix: "-vehicle-tile",
      saveHeart: heartProperties,
      filterType: isSimilarMatch ? "similar" : "exact"
    })]
  });
};
const VehicleTile = function (props) {
  var _dealer$status7, _vehicle$extColor, _vehicle$extColor2, _vehicle$intColor, _dealer$status8, _dealer$status9, _dealer$status10, _dealer$status11, _dealer$status12;
  const {
    vehicle,
    hasPreviousView,
    hasFilters,
    status,
    isSimilarMatch,
    presoldBadgeCopy = "SALE PENDING",
    onClick = function () {},
    onOffersClick = function () {},
    onEstimatePaymentsClick = function () {},
    detailsCTA,
    contactCTA,
    contactMonogramCTA,
    tileMsrpHeadingLabel,
    tileMsrpHeadingDisclaimer,
    msrpLegalText,
    enableCV,
    labelCompareVehicle,
    mileageDisclaimer
  } = props;
  const {
    vin,
    name,
    description,
    isSmartPath,
    isElectric,
    isPreSold,
    msrp,
    msrpCopy,
    priceObject,
    unlockPricingCTA,
    msrpLinks,
    dealer,
    inventoryStatus,
    interiorSwatch,
    exteriorSwatch,
    jelly,
    interiorJelly,
    priceData,
    vdpUrl,
    dealerSiteURL,
    stockNum,
    mileage,
    heartProperties,
    included,
    excluded,
    totalFilterCount
  } = vehicle || {};
  const themeContext = (0, _styledComponentThemes.useTheme)();
  const theme = typeof themeContext === "string" ? themeContext : themeContext === null || themeContext === void 0 ? void 0 : themeContext.theme;
  const [shouldRender, setShouldRender] = (0, _react.useState)(false);
  const fireAnalytics = (0, _analytics.default)("VehicleTile", {});
  const {
    compareVehicles,
    setCompareVehicles,
    updateIsFullCompareVehicles
  } = (0, _new.useSearchInventoryToolStore)({
    id: "search-inventory-tool"
  });
  const {
    model
  } = (0, _reactRouter.useParams)();
  const [, addToCompareVehicleCookie] = (0, _new.compareVehicleHandlerStorage)(model);
  const hasDealerIcon = !!(dealer !== null && dealer !== void 0 && (_dealer$status7 = dealer.status) !== null && _dealer$status7 !== void 0 && _dealer$status7.icon);
  const withIntsrcSearchParams = (0, _analytics.useAnalyticsQueryParam)({
    intsrc: "{brand}:{section}:{action}:{destination}"
  });
  const handlers = {
    offers: onOffersClick(vehicle, true),
    estimatePayments: onEstimatePaymentsClick(vehicle)
  };
  const handleCompareVehicle = function (event, vehicle) {
    let checked = false;
    if (event.target instanceof HTMLInputElement) {
      checked = event.target.checked;
    }
    if (checked) {
      if (compareVehicles.length === 3) {
        updateIsFullCompareVehicles(true);
        return;
      }
      const data = [...compareVehicles, {
        vin: vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin,
        dealer: vehicle === null || vehicle === void 0 ? void 0 : vehicle.dealer
      }];
      setCompareVehicles(data);
      addToCompareVehicleCookie(data);
    } else {
      const data = compareVehicles.filter(function (compareVehicle) {
        return (compareVehicle === null || compareVehicle === void 0 ? void 0 : compareVehicle.vin) !== (vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin);
      });
      setCompareVehicles(data);
      addToCompareVehicleCookie(data);
    }
  };
  const tabs = ["Exterior", "Interior"];
  const handleTabSelect = function (firstTab, lastTab) {
    fireAnalytics("tabClick", {
      prev: {
        heading: tabs[lastTab],
        index: lastTab
      },
      next: {
        heading: tabs[firstTab],
        index: firstTab
      }
    });
  };
  const [tileRef] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: "100%",
    threshold: 0,
    onChange: function (inView) {
      if (inView) {
        setShouldRender(true);
      }
    }
  });
  const hrefContactCTA = (0, _new.generateDealerUrlWithIntSrc)(vdpUrl, dealerSiteURL, withIntsrcSearchParams);
  if (!shouldRender) return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    style: {
      height: "614.2px"
    },
    "data-testid": "VehicleTile",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Tile, {
      ref: tileRef
    })
  });
  const LexusContactDealer = function () {
    const contactDealerCTAProps = isSmartPath ? contactMonogramCTA : contactCTA;
    if (contactDealerCTAProps !== null && contactDealerCTAProps !== void 0 && contactDealerCTAProps.text) return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TileCTA, {
      "data-testid": "LexusContactDealer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
        ...contactDealerCTAProps,
        target: "_blank",
        href: hrefContactCTA,
        isExternal: false
      })
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRP, {
      "data-testid": "LexusContactDealer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRPContactCopy, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: "Contact Dealer for Price"
        })
      })
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "data-testid": "VehicleTile",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Tile, {
      ref: tileRef,
      className: isSimilarMatch ? "isSimilarMatch" : "",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.VehicleTile, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(HeaderVehicleTile, {
          vin: vin,
          hasFilters: hasFilters,
          status: status,
          included: included,
          excluded: excluded,
          totalFilterCount: totalFilterCount,
          tileMsrpHeadingLabel: tileMsrpHeadingLabel,
          tileMsrpHeadingDisclaimer: tileMsrpHeadingDisclaimer,
          priceData: priceData,
          msrpLegalText: msrpLegalText,
          hasPreviousView: hasPreviousView,
          heartProperties: heartProperties,
          isSimilarMatch: isSimilarMatch,
          showDealerIcon: theme === _helper.LEXUS_THEME,
          dealer: dealer,
          isSmartPath: isSmartPath
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.NameWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Name, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: name ? name : "-"
            }), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.VinStockWrapper, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Vin, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: `VIN ${vin}`
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StockNum, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: stockNum ? `| Stock ${stockNum}` : ""
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.IsPendingContainer, {
          style: {
            opacity: isPreSold ? "1" : "0"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.IsPending, {
            children: presoldBadgeCopy
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactTabs.Tabs, {
          onSelect: handleTabSelect,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactTabs.TabList, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactTabs.Tab, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Swatch, {
                $hex: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$extColor = vehicle.extColor) === null || _vehicle$extColor === void 0 ? void 0 : _vehicle$extColor.hex,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
                  ...exteriorSwatch
                })
              }), "Exterior"]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactTabs.Tab, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Swatch, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
                  ...interiorSwatch
                })
              }), "Interior"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTabs.TabPanel, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TabContainer, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
                onClick: onClick(vehicle),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Jelly, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.JellyWrapper, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
                      ...jelly
                    })
                  })
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$extColor2 = vehicle.extColor) === null || _vehicle$extColor2 === void 0 ? void 0 : _vehicle$extColor2.label
                })
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTabs.TabPanel, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.TabContainer, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
                onClick: onClick(vehicle),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Jelly, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.JellyWrapper, {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaComponent.default, {
                      ...interiorJelly
                    })
                  })
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$intColor = vehicle.intColor) === null || _vehicle$intColor === void 0 ? void 0 : _vehicle$intColor.label
                })
              })]
            })
          })]
        }), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FlexContainer, {
          children: [theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRPContainer, {
            children: priceObject !== null && priceObject !== void 0 && priceObject.isDap ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRP, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PriceFormat.default, {
                  price: msrp
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRPCopy, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: msrpCopy
                })
              })]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRP, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.MSRPContactCopy, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                  children: "Contact Dealer for Price"
                })
              })
            })
          }), !(priceObject !== null && priceObject !== void 0 && priceObject.isDap) && theme === _helper.LEXUS_THEME && LexusContactDealer(), theme === _helper.TOYOTA_THEME ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.MSRPLinksContainer, {
            children: [unlockPricingCTA && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.UnlockLink, {
              ...unlockPricingCTA
            }), msrpLinks ? msrpLinks.map(function (msrpLink) {
              return msrpLink.isActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
                ...msrpLink,
                onClick: handlers[msrpLink.handler]
              });
            }) : null]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TileCTA, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
              ...detailsCTA,
              onClick: onClick(vehicle)
            })
          })]
        }), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Divider, {}), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FlexContainerColumn, {
          children: [mileage > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FlexRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Icon, {
              as: _IconLibrary.Mileage
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FlexText, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: `${mileage} miles`
              }), mileageDisclaimer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Disclaimer.default, {
                theme: theme,
                text: mileageDisclaimer
              })]
            })]
          }), description && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.FlexRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Icon, {
              as: isElectric ? _IconLibrary.EngineElectric : _IconLibrary.Engine
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FlexText, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: description
              })
            })]
          })]
        }), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerInfo, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerName, {
            className: hasDealerIcon ? "hasDealerIcon" : "",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: dealer !== null && dealer !== void 0 && dealer.name ? dealer.name : "-"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerDistance, {
              children: ["(", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: (dealer === null || dealer === void 0 ? void 0 : dealer.distance) !== null && (dealer === null || dealer === void 0 ? void 0 : dealer.distance) !== undefined && (dealer === null || dealer === void 0 ? void 0 : dealer.distance) >= 0 ? `${dealer.distance} mi` : "- mi"
              }), ")"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.DealerIconContainer, {
            className: !hasDealerIcon ? "hasNoDealerIcon" : "",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.DealerIcon, {
              src: dealer === null || dealer === void 0 ? void 0 : (_dealer$status8 = dealer.status) === null || _dealer$status8 === void 0 ? void 0 : _dealer$status8.icon,
              alt: dealer === null || dealer === void 0 ? void 0 : (_dealer$status9 = dealer.status) === null || _dealer$status9 === void 0 ? void 0 : _dealer$status9.alt
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreInfoTooltip.default, {
              maxWidth: 360,
              content: {
                copy: dealer === null || dealer === void 0 ? void 0 : (_dealer$status10 = dealer.status) === null || _dealer$status10 === void 0 ? void 0 : _dealer$status10.info
              },
              brand: theme,
              bindings: dealer === null || dealer === void 0 ? void 0 : (_dealer$status11 = dealer.status) === null || _dealer$status11 === void 0 ? void 0 : _dealer$status11.bindings,
              title: dealer === null || dealer === void 0 ? void 0 : (_dealer$status12 = dealer.status) === null || _dealer$status12 === void 0 ? void 0 : _dealer$status12.alt
            })]
          })]
        }), theme === _helper.TOYOTA_THEME && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.TileCTA, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LexusButton.default, {
            ...detailsCTA,
            onClick: onClick(vehicle)
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.InventoryStatus, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: inventoryStatus
          })
        }), enableCV && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.StyledCompareVehicleToggle, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CompareVehicleToggle.default, {
            vehicle: {
              vin,
              dealer
            },
            vehicles: compareVehicles,
            onChange: handleCompareVehicle,
            text: labelCompareVehicle
          })
        })]
      })
    })
  });
};
exports.VehicleTile = VehicleTile;
const themedVehicleTile = (0, _styledComponentThemes.withThemes)(VehicleTile, Themes);
var _default = exports.default = /*#__PURE__*/(0, _react.memo)((0, _analytics.withAnalytics)(themedVehicleTile)({}));